import { createSlice } from '@reduxjs/toolkit';

// Define a type for the slice state
interface IImportDataState {
	data: Array<File>,
	showLoading: ILoading,
	isLoading: boolean,
	isSuccess: boolean,
}

// Define the initial state using that type
const initialState: IImportDataState = {
	data: [],
	showLoading: {
		sourceAction: '',
		state: false
	},
	isLoading: false,
	isSuccess: false,
};

export const importDataSlice = createSlice({
	name: 'importData',
	initialState,
	reducers: {
		setLoading: (state, action) => {
			state.showLoading = {
				sourceAction: action.payload.sourceAction,
				state: true,
			};
			state.isLoading = action.payload.isLoading ? action.payload.isLoading : false;
			state.isSuccess = action.payload.isSuccess ? action.payload.isSuccess : false;
		},
		resetLoading: (state, action) => {
			state.showLoading = {
				sourceAction: '',
				state: false
			};
			state.isLoading = action.payload.isLoading ? action.payload.isLoading : false;
			state.isSuccess = action.payload.isSuccess ? action.payload.isSuccess : false;
		},
		importRack: (state, action) => {
			const newFile = action.payload.data;
			state.data = [newFile, ...state.data];
		}
	},
});

export const importDataActions = importDataSlice.actions;

export default importDataSlice.reducer;